<template>
    <el-drawer
        title="批改设置"
        :visible.sync="show"
        :wrapperClosable="false"
        direction="rtl"
        size="600px"
        :before-close="close">
        <div class="panel">
            <el-form ref="form" :model="form" label-width="150px" class="edit_form" >
                <el-form-item label="批改题目数量">
                    <el-radio v-model="form.countEnable" :label="false">不限数量</el-radio>
                    <el-radio v-model="form.countEnable" :label="true">指定数量</el-radio>
                </el-form-item>
                <el-form-item label="自定义数量" v-if="form.countEnable==true">
                    <el-input-number v-model="form.markingCount"  :min="1"  label=""></el-input-number>
                </el-form-item>
                <el-form-item label="批改题目序号">
                    <el-radio-group v-model="form.randomEnable">
                        <el-radio :label="true">随机题目</el-radio>
                        <el-radio :label="false">指定题目</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item  v-if="!form.randomEnable">
                    <el-tree ref="tree"
                        class="fx-g1 func_tree"
                        :data="tree"
                        show-checkbox
                        node-key="id"
                        :default-expand-all="true"
                        :default-checked-keys="item.markingQuestionIds ? item.markingQuestionIds.split(',') : []"
                        :expand-on-click-node="false"
                        :props="defaultProps">
                    </el-tree>
                </el-form-item>
            </el-form>
        </div>
        <span  class="fx fx-center">
            <el-button type="primary" @click="sub()">确 定</el-button>
            <el-button @click="close()">关 闭</el-button>
        </span>
    </el-drawer>
</template>
<style scoped>
    .edit_form {
        margin-top: 20px;
        width: 88%;
    }
</style>
<script>
    export default {
        props: [
            "item",
        ],
        data() {
            return {
                show: false,
                form: {
                    ...this.item,
                    "questionIds": (this.item.markingQuestionIds ? this.item.markingQuestionIds.split(",") : [])
                },
                pager: {
                    pageSize: 12,
                    dataTotal: 0,
                    currentPage: 1
                },
                activeName: 'countEnable',
                tree:[{
                    id: 0,
                    name: '全选',
                    children: [
                        // {
                        //     id: 5,
                        //     name: '二级 1-1',score:0,
                        //     },
                        //     {
                        //     id: 2,
                        //     name: '二级 1-2'
                        //     }, {
                        //     id: 3,
                        //     name: '二级 1-3'
                        // }
                    ]
                }],
                needRefreshParent: false,
                defaultProps: {
                    children: 'children',
                    label: 'question',
                    disabled:''
                },
            }

        },
        watch: {

        },

        methods: {
            close() {
                if (this.needRefreshParent) {
                    this.$emit("submit");
                } else {
                    this.$emit("close");
                }
            },
            loadQuestions() {//question  景岗那边还没弄好 接口暂时写在考试controller
                this.$ajaxPost("/exam/questionTree" ,{
                    examId:this.item.examId
                }, (data) => {
                    data.result[0].question = "全部";
                    this.tree = data.result;
                })
            },
            sub() {
                if(!this.form.randomEnable ){
                    var nodes = this.$refs.tree.getCheckedNodes().filter(n => n.id != 0);
                    let checkIds = nodes.map(n => n.id).join(',');
                    let checkNames = nodes.map(n => n.question).join('、');
                    this.form.markingQuestionIds = checkIds;
                    this.form.markingQuestionNames = checkNames;
                    if(this.form.markingQuestionIds == ""){
                        this.$showError("必须指定题目");
                        return;
                    }
                }
                let data = {...this.form};
                this.$ajaxPost("/examMarker/modifyExamMarker", {
                    examMarker: data
                }, (data) => {
                    this.show = false;
                    this.$showSuccess("添加成功");
                    this.needRefreshParent = true;
                    this.$emit("submit", data.result);
                })
                return false;
            },
        },
        mounted() {
            this.show = true;
        },
        created() {
            this.loadQuestions();
        }


    }
</script>
